// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YrKn","colBig":"styles_colBig__3Hy5l","colSmall":"styles_colSmall__3iJh5"};